import type { Command } from "commander";
import { refreshAiModelsCatalog, verifyAiModelsCatalog } from "../../catalog/index.js";
import { emitHuman, emitJson } from "../report.js";

export function registerCatalogCommand(program: Command): void {
  const catalog = program.command("catalog").description("Model catalog load and health commands");

  catalog
    .command("refresh")
    .description("Fetch catalogs from open-assets.x12i.com and warm the cache")
    .option("--bundled-only", "Use bundled src/data catalogs only (no HTTP)")
    .option("--json", "Machine-readable JSON on stdout")
    .action(async (opts: { bundledOnly?: boolean; json?: boolean }) => {
      const result = await refreshAiModelsCatalog({ bundledOnly: opts.bundledOnly });
      if (opts.json) {
        emitJson(result);
      } else {
        emitHuman([
          "✔  Catalog refresh complete",
          `  Direct: ${result.directCount} (${result.directSource})`,
          `  OpenRouter: ${result.openRouterCount} (${result.openRouterSource})`,
        ]);
      }
    });

  catalog
    .command("verify")
    .description("Validate direct + OpenRouter catalogs load successfully")
    .option("--bundled-only", "Use bundled src/data catalogs only (no HTTP)")
    .option("--json", "Machine-readable JSON on stdout")
    .action(async (opts: { bundledOnly?: boolean; json?: boolean }) => {
      const report = await verifyAiModelsCatalog({ bundledOnly: opts.bundledOnly });

      if (opts.json) {
        emitJson(report);
      } else {
        emitHuman([
          report.ok ? "✔  Catalog verification passed" : "✗  Catalog verification FAILED",
          `  Direct models:     ${report.directCount} (${report.directSource})`,
          `  OpenRouter models: ${report.openRouterCount} (${report.openRouterSource})`,
          `  Direct URL:        ${report.directUrl}`,
          `  OpenRouter URL:    ${report.openRouterUrl}`,
        ]);
      }

      if (!report.ok) {
        process.exit(1);
      }
    });
}
